import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import $ from 'jquery';
import './Textarea.scss';

class Textarea extends React.Component {
  static propTypes = {
    /** custom className of the element. */
    className: PropTypes.string,
    /** function to call when value changed. */
    onChange: PropTypes.func,
    /** placeholder of the element. */
    placeholder: PropTypes.string,
    /** value of the element. */
    value: PropTypes.any,
    /** whether to autoGrow or not. */
    autoGrow: PropTypes.bool,
    /** minHeight of the element. */
    minHeight: PropTypes.number,
    /** maxHeight of the element. */
    maxHeight: PropTypes.number,
    /** word limit of the element. */
    wordLimit: PropTypes.number,
  };

  static defaultProps = {
    className: '',
    onChange: () => {},
    autoGrow: true,
    minHeight: 100,
    maxHeight: 205,
    wordLimit: 400,
    placeholder: '내용을 입력해주세요.',
  };

  state = {
    valid: true,
  };

  componentDidMount() {
    const { autoGrow } = this.props;

    this.maxHeight = parseInt($(this.input).css('maxHeight'));
    if (autoGrow) {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  }

  componentDidUpdate(prevProps) {
    const { autoGrow, value } = this.props;
    if (autoGrow && value !== prevProps.value) {
      this.handleResize();
    }
  }

  componentWillUnmount() {
    if (this.props.autoGrow) {
      window.removeEventListener('resize', this.handleResize);
    }
  }

  handleResize = () => {
    const newHeight = $(this.mirror).outerHeight();

    this.input.style.height = `${newHeight}px`;
    this.input.style.overflow = newHeight >= this.maxHeight ? 'auto' : 'hidden';
  };

  onChange(e) {
    const { onChange, wordLimit } = this.props;
    onChange(e.target.value);

    if (wordLimit) {
      const exceed = this.sanitize(e.target.value).length <= wordLimit;
      this.setState({ valid: exceed });
    }
  }

  sanitize = text => {
    return text ? text.replace(/(\s)\1+/g, '$1').trim() : '';
  };

  renderLimit() {
    const { value, wordLimit } = this.props;
    if (!wordLimit) {
      return null;
    }

    const text = this.sanitize(value);
    return (
      <div
        className={classnames('common-textarea__word-limit', {
          'common-textarea__word-limit--exceeded':
            text !== '' && text.length > wordLimit,
        })}
      >
        {`${text.length} / ${wordLimit}`}
      </div>
    );
  }

  render() {
    const {
      autoGrow,
      value,
      placeholder,
      className,
      minHeight,
      maxHeight,
    } = this.props;

    const mirror = autoGrow && (
      <div
        ref={ref => (this.mirror = ref)}
        className={classnames(
          'common-textarea',
          'common-textarea--mirror',
          className
        )}
      >
        {value}
        <br />
      </div>
    );

    return (
      <div className={classnames('common-input', 'common-textarea-container')}>
        <textarea
          ref={ref => (this.input = ref)}
          style={{ minHeight: `${minHeight}px`, maxHeight: `${maxHeight}px` }}
          className={classnames('common-textarea', className, {
            'common-textarea--invalid': !this.state.valid,
          })}
          onChange={e => this.onChange(e)}
          placeholder={placeholder}
          value={value}
        />
        {this.renderLimit()}
        {mirror}
      </div>
    );
  }
}

export default Textarea;



// WEBPACK FOOTER //
// ./src/components/common/textarea/Textarea.js